import React, { Component } from 'react';
import * as utils from '../../shared/ClientUtils';
import AdvBasicTable from '../common/AdvBasicTable';
import AdvTippedText from '../common/AdvTippedText';
import AdvVerticalData from '../common/AdvVerticalData';

export class VisitorStatBox extends Component {
  render() {
    return this.props.allUniqueCountries ? (
      <AdvBasicTable
        title='Visitor Info'
        columns={[
          {
            title: '',
            key: 'statName',
          },
          {
            title: 'All',
            key: 'total',
          },
          {
            title: 'Members',
            key: 'members',
          },
          {
            title: 'Guests',
            key: 'guests',
          },
        ]}
        data={[
          {
            statName: 'Total',
            total: this.props.total,
            members: this.props.members,
            guests: this.props.guests,
          },
          {
            statName: 'Unique',
            total: this.props.unique,
            members: this.props.uniqueMembers,
            guests: this.props.uniqueGuests,
          },
        ].concat(
          this.props.allUniqueCountries.map((country) => ({
            statName: country || 'Unknown Country',
            total:
              (this.props.guestCountryCounts[country] || 0) +
              (this.props.memberCountryCounts[country] || 0),
            members: this.props.memberCountryCounts[country] || 0,
            guests: this.props.guestCountryCounts[country] || 0,
          }))
        )}
      />
    ) : (
      <div></div>
    );
  }
}

export default VisitorStatBox;
